<div class="header">
  {{ featureRestrictionTranslations[restrictionType].modalTitle | translate }}
</div>
<div class="content">
  <div class="ui">
    <p [innerHTML]="featureRestrictionTranslations[restrictionType].modalContent | translate"></p>
  </div>
</div>
<div class="horizontal-separator"></div>
<div class="actions">
  <button
    class="ui grey basic button"
    (click)="modal.deny(undefined)"
    autofocus
    data-lokalise
    data-key="txt_cancel"
  ></button>
  <button class="ui purple button" (click)="onApprove()" autofocus>
    {{ showContactSalesButton ? ('txt_gelato_gold_modal_contact_sales' | translate) : ('txt_subscribe' | translate) }}
  </button>
</div>
